<!--
Author: TangChen
Date: 2019-04-08
Desc: 图片上传
 -->
<template>
    <div class="comp-img-upload comp">
        <el-row class="up-list" :span="24">
            <el-form v-if="flag === '0'" ref="img" :model="img" :rules="rules" v-on:submit.native.prevent>
                <el-form-item label="" prop="idCard">
                    <p class="up-list-mes">
                        1、本人有效身份证正反面照
                    </p>
                    <div class="img-up-box">
                        <div class="img-up-list el-upload-list--picture-card">
                            <div v-if="imgBase64.front" class="el-upload-list__item-actions">
                                <i class="el-icon-zoom-in" v-on:click="handlePictureCardPreview('front')" />
                                <i class="el-icon-delete" v-on:click="delImg('front')" />
                            </div>
                            <el-input
                                ref="front"
                                v-model="img.front"
                                type="file"
                                name="front"
                                :accept="accept"
                                v-on:change="getImgBase"
                            />
                            <div class="img-up">
                                <img v-if="imgBase64.front" :src="imgBase64.front">
                                <i v-if="!imgBase64.front" class="el-icon-plus" />
                                <span v-if="!imgBase64.front" class="img-text">手持身份证正面</span>
                            </div>
                        </div>
                        <div class="img-up-list el-upload-list--picture-card">
                            <div v-if="imgBase64.back" class="el-upload-list__item-actions">
                                <i class="el-icon-zoom-in" v-on:click="handlePictureCardPreview('back')" />
                                <i class="el-icon-delete" v-on:click="delImg('back')" />
                            </div>
                            <el-input
                                ref="back"
                                v-model="img.back"
                                type="file"
                                name="back"
                                :accept="accept"
                                v-on:change="getImgBase"
                            />
                            <div class="img-up">
                                <img v-if="imgBase64.back" :src="imgBase64.back">
                                <i v-if="!imgBase64.back" class="el-icon-plus" />
                                <span v-if="!imgBase64.back" class="img-text">手持身份证反面</span>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="" prop="asset">
                    <p class="up-list-mes">
                        2、金融机构出具的金融资产不低于300万元的资产证明（加盖金融机构业务专用章），或者最近3年个人年均收入不低于30万元的证明（加盖公司公章）
                    </p>
                    <div class="img-up-list el-upload-list--picture-card">
                        <div v-if="imgBase64.asset" class="el-upload-list__item-actions">
                            <i class="el-icon-zoom-in" v-on:click="handlePictureCardPreview('asset')" />
                            <i class="el-icon-delete" v-on:click="delImg('asset')" />
                        </div>
                        <el-input
                            ref="asset"
                            v-model="img.asset"
                            type="file"
                            name="asset"
                            :accept="accept"
                            v-on:change="getImgBase"
                        />
                        <div class="img-up">
                            <img v-if="imgBase64.asset" :src="imgBase64.asset">
                            <i v-if="!imgBase64.asset" class="el-icon-plus" />
                            <span v-if="!imgBase64.asset" class="img-text">资产证明</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="" prop="invest">
                    <p class="up-list-mes">
                        3、相关金融机构出具的最近2年证券、基金、期货、黄金、外汇等投资记录原件（如对账单或交易流水，加盖金融机构业务专用章），或最近2年从事金融产品设计、投资、风险管理及相关工作经历的工作证明（加盖单位公章）
                    </p>
                    <div class="img-up-list el-upload-list--picture-card">
                        <div v-if="imgBase64.invest" class="el-upload-list__item-actions">
                            <i class="el-icon-zoom-in" v-on:click="handlePictureCardPreview('invest')" />
                            <i class="el-icon-delete" v-on:click="delImg('invest')" />
                        </div>
                        <el-input
                            ref="invest"
                            v-model="img.invest"
                            type="file"
                            name="invest"
                            :accept="accept"
                            v-on:change="getImgBase"
                        />
                        <div class="img-up">
                            <img v-if="imgBase64.invest" :src="imgBase64.invest">
                            <i v-if="!imgBase64.invest" class="el-icon-plus" />
                            <span v-if="!imgBase64.invest" class="img-text">工作经历证明</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="" class="btn-center">
                    <el-button type="primary" class="medium" v-on:click="submitInfo()">
                        上传
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        还未准备好
                    </el-button>
                </el-form-item>
            </el-form>
            <el-form v-else ref="img" :model="img" :rules="rules" v-on:submit.native.prevent>
                <el-form-item label="" prop="qualified">
                    <p class="up-list-mes">
                        1、测试测试测试合格投资者证件照或文件测试测试测试
                    </p>
                    <div class="img-up-list el-upload-list--picture-card">
                        <div v-if="imgBase64.qualified" class="el-upload-list__item-actions">
                            <i class="el-icon-zoom-in" v-on:click="handlePictureCardPreview('qualified')" />
                            <i class="el-icon-delete" v-on:click="delImg('qualified')" />
                        </div>
                        <el-input
                            ref="qualified"
                            v-model="img.qualified"
                            type="file"
                            name="qualified"
                            :accept="accept"
                            v-on:change="getImgBase"
                        />
                        <div class="img-up">
                            <img v-if="imgBase64.qualified" :src="imgBase64.qualified">
                            <i v-if="!imgBase64.qualified" class="el-icon-plus" />
                            <span v-if="!imgBase64.qualified" class="img-text">合格投资者证明</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="" class="btn-center">
                    <el-button type="primary" class="medium" v-on:click="submitInfo()">
                        上传
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        还未准备好
                    </el-button>
                </el-form-item>
            </el-form>
            <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl">
            </el-dialog>
        </el-row>
    </div>
</template>
<script>
export default {
    name: "ImgUpload",
    props: {
        flag: {
            type: String,
            default: "0"
        }
    },
    data () {
        return {
            dialogImageUrl: "",
            dialogVisible: false,
            accept: "image/jpg,image/jpeg,.doc,.docx",
            img: {
                idCard: "",
                front: "",
                back: "",
                asset: "",
                invest: "",
                qualified: ""
            },
            imgBase64: {
                front: "",
                back: "",
                asset: "",
                invest: "",
                qualified: ""
            },
            rules: {
                idCard: [
                    { validator: this.validateImg, trigger: "change" }
                ],
                asset: [
                    { required: true, message: "请选择资产证明文件上传", trigger: "change" }
                ],
                invest: [
                    { required: true, message: "请选择工作经历证明文件上传", trigger: "change" }
                ],
                qualified: [
                    { required: true, message: "请选择合格投资者文件上传", trigger: "change" }
                ]
            },
            upload_url: "/acct/changetype/upload",
            uploadForm: new FormData()
        };
    },
    watch: {
        "img.front" (val) {
            this.img.idCard = (val && this.img.back) ? "1" : "";
        },
        "img.back" (val) {
            this.img.idCard = (val && this.img.front) ? "1" : "";
        }
    },
    mounted () {
    },
    methods: {
        handlePictureCardPreview (filename) {
            this.dialogImageUrl = this.imgBase64[filename];
            this.dialogVisible = true;
        },
        validateImg (rule, value, callback) {
            if (value) {
                callback();
            } else {
                if (!this.img.front && !this.img.back) {
                    callback(new Error("请上传手持身份证正反面文件"));
                }
                if (!this.img.front) {
                    callback(new Error("请上传手持身份证正面文件"));
                }
                if (!this.img.back) {
                    callback(new Error("请上传手持身份证反面文件"));
                }
            }
        },
        submitInfo () {
            const _this = this;
            _this.upload_url = _this.$route.query.flag === "1" ? "pef/file/upload/base64" : "/acct/changetype/upload/base64";
            const _x = this.$util.src(_this.upload_url,{},true);
            _this.$refs.img.validate(valid => {
                if (valid) {
                    this.$req({
                        method: "POST",
                        url: _x,
                        timeout: 20000,
                        data: _this.imgBase64,
                        headers: { "Content-Type": "multipart/form-data" }
                    }).then(res => {
                        if (res.code === "0000000") {
                            _this.$emit("success", true);
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(() => { });
                } else {
                    return false;
                }
            });
        },
        getImgBase () {
            const _this = this;
            const event = window.event;
            const file = event.target && event.target.files[0];
            let k = 0;
            if (!file) {
                this.delImg(event.target.name);
                return false;
            }
            if(!(event.target.value.indexOf(".jpg") > -1 || event.target.value.indexOf(".jpeg") > -1 || event.target.value.indexOf(".doc") > -1 || event.target.value.indexOf(".docx") > -1)){
                this.delImg(event.target.name);
                this.$message.warning("只能上传jpg/jpeg,doc/docx文件，请重新上传");
                return false;
            }
            if (file.size > 1024 * 1024) {
                this.img[event.target.name] = "";
                this.$message.warning("上传文件大小超过限制大小1M，不能上传");
                return;
            }
            for (let i in this.img) {
                if (this.img[i] && file.name === this.img[i].split("\\").pop()) k++;
            }
            if (k === 2) {
                this.delImg(event.target.name);
                this.$message.warning("不能上传相同名称的文件，请重新上传");
                return false;
            }
            const reader = new FileReader();
            // 转base64
            reader.onload = function (e) {
                _this.$set(_this.imgBase64, event.target.name, e.target.result);
            };
            try{
                this.uploadForm.delete(event.target.name);
            }catch (e) {
                console.log(e);
            }
            this.uploadForm.append(event.target.name, file);
            reader.readAsDataURL(file);
        },
        // 删除图片
        delImg (index) {
            this.imgBase64[index] = "";
            if (this.img[index]) {
                this.img[index] = "";
                this.uploadForm.delete(index);
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-img-upload {
    .btn-center {
        text-align: center;
    }
    .up-list {
        padding: 20px 0;
        .up-list-mes {
            font-size: $f16;
            color: $text-color2;
            line-height: 30px;
        }
        .img-up-list {
            margin-top: 20px;
            display: inline-block;
            position: relative;
            .el-upload-list__item-actions {
                z-index: 100;
                i {
                    font-size: $f24;
                    cursor: pointer;
                }
                i:last-of-type {
                    margin-left: 20px;
                }
            }
            .el-input {
                position: absolute;
                top: 10px;
                left: 0;
                opacity: 0;
                z-index: 10;
            }
            .img-up,
            .el-input .el-input__inner {
                width: 240px;
                height: 150px;
                line-height: 150px;
                cursor: pointer;
            }
            .img-up {
                text-align: center;
                border: 3px dashed $border-color4;
                border-radius: 10px;
                background-color: $bg1;
                overflow: hidden;
                img {
                    width: 240px;
                    height: 150px;
                    display: inline-block;
                }
            }
            .img-text {
                vertical-align: middle;
                font-size: $f20;
            }
            .el-icon-plus {
                vertical-align: middle;
                font-size: $f26;
                margin-right: 7px;
                color: inherit;
                font-weight: bold;
            }
        }
        .img-up-box {
            .img-up-list {
                vertical-align: middle;
                &:last-of-type {
                    margin-left: 24px;
                }
            }
        }
    }
}
</style>
